// extracted by mini-css-extract-plugin
export var scrollArea = "_rb-0";